import { get, groupBy } from "lodash";
import moment from "moment";

// ENG-1116: date parsing is deliberately lenient (moment falls back to Date) for backwards compatibility
export const validateDate = (d: any) => {
  if (typeof d === "undefined") return undefined;
  const m = moment.utc(d);
  return m.isValid() ? m.format("YYYY-MM-DD") : undefined;
};

export const validateBoolean = (v: any) => {
  if (v === true || v === false) return v;
  if (v === "true") return true;
  if (v === "false") return false;
  if (v === "N") return false;
  if (v === "Y") return true;
  return undefined;
};

export const validateGuid = (v: string) => v.replace("/", "-");

export const mapTo = (x: any, y: any) => {
  if (!y || typeof y !== "object") return null;
  return y[x] ? y[x] : null;
};

export const split = (value: string, char: string) => {
  if (value && typeof value === "string") return value.split(char);
  return [""];
};

// ENG-1116: date parsing is deliberately lenient (moment falls back to Date) for backwards compatibility.
// biome-ignore lint/style/useDefaultParameterLast: positional signature is called by stored mapping templates
export const excludeByDate = (values: any[], d: any, field: string, inclusive = true, exclude: boolean) => {
  const threshold = moment.utc(d);
  if (!threshold.isValid()) return values;
  const cmp = threshold.valueOf();

  const result: any[] = [];
  for (const item of values) {
    const fieldValue = get(item, field);
    if (!fieldValue) continue;
    const itemDate = moment.utc(fieldValue);
    if (!itemDate.isValid()) continue;
    const itemCmp = itemDate.valueOf();

    if (exclude) {
      if (inclusive ? itemCmp <= cmp : itemCmp < cmp) result.push(item);
    } else if (inclusive ? itemCmp >= cmp : itemCmp > cmp) {
      result.push(item);
    }
  }
  return result;
};

/** Given an array of records return an array of `{ key, values }` groups for a given field. */
export const groupFunc = (records: any, field: any) => {
  const grouped = groupBy(records, field);
  return Object.keys(grouped).map((key) => ({ key, values: grouped[key] }));
};

/** Drops records whose `field` value is one of `excludeValues`. Non-arrays pass through. */
export const filterByField = (records: any, field: string, excludeValues: any[] = [null, 0, "0"]) => {
  if (!Array.isArray(records)) return records;
  return records.filter((record) => !excludeValues.includes(record[field]));
};

/** Helper functions exposed to json-e mapping templates. */
export const mappingFunctions = {
  excludeByDate,
  validateBoolean,
  validateGuid,
  validateDate,
  get,
  mapTo,
  split,
  groupBy: groupFunc,
  filterByField,
};
